import * as React from 'react';

import { flameTheme } from '@lightspeed/flame/Core';
import { IconChevronLeft } from '@lightspeed/flame/Icon/ChevronLeft';

import { TextLinkButton } from './BackButton.style';

const { colors } = flameTheme;

interface BackButtonProps {
  onClick: () => void;
  content?: string;
}

const BackButton: React.FunctionComponent<BackButtonProps> = ({ onClick, content }) => {
  return (
    <TextLinkButton
      slim
      color={colors['blue-500']}
      onClick={() => {
        onClick();
      }}
      data-test="back-button-with-chevron"
    >
      <IconChevronLeft baseColor="#232A3B" />
      {content || 'Back'}
    </TextLinkButton>
  );
};

export { BackButton };
